<script>
import axios from '@/utils/axios';
import { allUsers } from '@/utils/user';
import units from "@/assets/json/units.json";
import { byDocumentType } from '@/utils/document-setting';
import { documentTemplates } from '@/utils/document-template';
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { downloadPDF as downloadPDFUtil } from '@/utils/pdf-download';
import DocumentPlaceholder from '@/components/common/proposal-placeholder.vue';
import { useCountryStore } from '@/stores/useCountryStore';
import { useStatesStore } from '@/stores/useStatesStore';

export default {
  components: {
   DocumentPlaceholder 
  },
  inject: ['setLoading'],
  data() {
    return {
      id: '',
      ids: [],
      users: [],
      gst_no: '',
      modal_title: '',
      type: 'proposal',
      subject: '',
      to_name: '',
      to_email: '',
      to_phone: '',
      to_address: '',
      to_city: '',
      to_pincode: '',
      to_state: null,
      to_country: null,
      selectedLead: null,
      status: null,
      tax_mode: null,
      selectedTax: null,
      proposal_date: '',
      valid_until: '',
      editorConfig: {
              toolbar: {
        items: ['bold', 'italic']
      },
      // 🔧 RESIZEOBSERVER FIX
      resize_enabled: false, 
      resize_image: {
        resizeOptions: [
          { name: 'resize-original', label: 'Original', value: null }
        ]
      }
      },
      sales_person_id: null,
      editor: ClassicEditor,
      statuses: ['Draft', 'Sent', 'Accepted', 'Rejected'],
      tax_modes: ['Item', 'Invoice'],
      countries: [],
      taxes: [],
      leads: [],
      allItems: [],
      items: [
        { item: null, description: '', unit: '', hsn_code: '', price: 0, qty: 1, amount: 0 }
      ],
      discount: 0,
      states: [],
      loading: false,
      action: '',
      acceptance_name: '',
      acceptance_email: '',
      currency: '',
      mass_delete: false,
      remark: '',
      users: [],
      user_id: null,
      units: units,
      assignment_history: [],
      previewData: null,
      errors: {},
      settings:{
       terms: '', 
       mail_subject: "Proposal from {entity_name}",
       mail_body: "Dear {client_name}, <br> Please find the details of the proposal {proposal_subject} below. Explore the proposal and accept if you find it perfect for you.",
       mail_footer: "<b>Questions about the Proposal?</b> <br>If you need to modify the proposal or have questions about the details in the proposal, please reach out to the sender by emailing them directly.<b> <br><br>Do Not Share This Email</b> <br>This email contains a secure link to your proposal. Please do not share this email, link, or access code with others. <br><br>Thank You, <br>{sender_name}, <br>M:{sender_mobile}", 
       send_on_email: false,
      },
      templates: [],
      template: null,
      document_template_id: null,
      should_send_mail: false,
    };
  },

  computed: {
   totalAmount(){
    return this.items.reduce((sum, row) => sum + row.amount, 0);
   },

   taxAmount() {
    if(this.tax_mode === 'Invoice'){
     const tax_rate = this.selectedTax?.rate || 0;
     const taxable_amount = this.totalAmount - this.discount;
     return (taxable_amount * tax_rate) / 100;
    }else{
     // Item mode - sum taxes from individual items using selectedTax
     return this.items.reduce((sum, row) => {
      const itemTaxRate = row.selectedTax?.rate || 0;
      return sum + (row.amount * itemTaxRate / 100);
     }, 0);
    }
   },

   grandTotal(){
    const discountAmount = parseFloat(this.discount) || 0;
    return Math.max(0, this.totalAmount - discountAmount) + this.taxAmount;
   },

   showTaxInfo(){
    return !(this.tax_mode === 'Item' && this.clientSetting?.tax_type === 'inclusive');
   }

  },

  // mounted(){
  //  this.getCountries();
  // },

  watch:{
   
   discount(newVal){
    if (this.totalAmount === 0 || !this.totalAmount) return;
    if(newVal < 0){
     this.discount = 0;
     this.$swalToast("Discount cannot be negative", 'warning');
    }else if(newVal > this.totalAmount){
     this.discount = this.totalAmount;
     this.$swalToast("Discount cannot exceed total amount", 'warning');
    }
   },

  },

 methods: {
  add(){
   this.getUsers();    
   this.resetForm();
   this.getCountries();
   this.getTaxes();
   this.getAllItems();
   this.byType(this.type);
   this.tax_mode = 'Item';
   this.status = "Draft";
   this.allDocumentTemplates();
   this.proposal_date = this.$currentDate();
   this.valid_until = this.$currentDate(7);
  }, 

  setDefaultSalesPerson(){
   const meInUsers = this.users.find(u => u.id === this.auth?.id);
   if(meInUsers){
    this.sales_person_id = meInUsers.id;
   }
  },

  async getUsers(){
   try{
    const response = await allUsers();
    this.users = response.data.data;
    if(!this.id){
     this.setDefaultSalesPerson(); 
    }
   }catch(error){
    this.$swalToast(error.message, 'error');
   }
  },

  async allDocumentTemplates(){
   try{
    const response = await documentTemplates(this.type);
    this.templates = response.data.data;
    if(this.id){
     this.template = this.templates.find(t => t.id === this.document_template_id) || null;
    }else{
     // CREATE MODE: Use default document_template_id or first template
     const defaultTemplate = this.templates.find(t => t.id === this.document_template_id) || 
                             (this.templates.length > 0 ? this.templates[0] : null);
     this.template = defaultTemplate;
    }
   }catch(error){
    this.$swalToast(error.message, 'error');
   }finally{
    this.setLoading(false);
   }
  },

  async byType(type){
   this.setLoading(true);
   try{
    const response = await byDocumentType(type, this.clientAdmin?.id);
    const data = response.data.data;
    this.settings = {
     mail_subject: data?.mail_subject || '',
     mail_body: data?.mail_body || '',
     mail_footer: data?.mail_footer || '',
     terms: data?.terms || '',
     send_on_email: data?.send_on_email || false,
    };
    this.document_template_id = data?.document_template_id;
   }catch(error){
    this.$swalToast(error.message, 'error');
   }finally{
    this.setLoading(false);
   }
  },  

  // async getCountries(){
  //  this.setLoading(true);
  //  try{
  //   const response = await axios.get('/countries');
  //   this.countries = response.data.data;
  //  }catch(error){
  //   this.$swalToast(error.message, 'error');
  //  }finally{
  //   this.setLoading(false);
  //  } 
  // },

  async getCountries(){
  const store = useCountryStore()
  this.countries = await store.loadCountries()
},

  async editProposal(proposal_public_token){
   try{
    this.setLoading(true);
    this.getCountries();
    this.getTaxes();
    this.getAllUsers();
    this.byType(this.type);
    this.allDocumentTemplates();
    await this.getAllItems(); 

    const response = await axios.get(`/proposals/${proposal_public_token}`);
    const data = response.data.data;

    this.document_template_id = data.document_template_id;

    await this.getLeadById(data.lead_id);

    this.id = data.id;
    this.subject = data.subject;
    this.to_name = data.to_name;
    this.to_email = data.to_email;
    this.to_phone = data.to_phone;
    this.gst_no = data.gst_no;
    this.to_address = data.to_address;
    this.to_city = data.to_city;
    this.to_pincode = data.to_pincode;
    this.to_country = (data.to_country != '') ? this.countries.find(c => c.name === data.to_country) : null;
    if(this.to_country?.id) await this.onCountrySelect(this.to_country);
    this.to_state = (data.to_state != '') ? this.states.find(s => s.name === data.to_state) : null;
    this.status = data.status;
    this.tax_mode = data.tax_mode;
    this.proposal_date = data.proposal_date;
    this.valid_until = data.valid_until;
    this.settings.terms = data.terms || '';
    this.selectedTax = this.taxes.find(t => t.id === data.tax_id) || null;
    this.discount = parseFloat(data.discount || 0);
    this.sales_person_id = data.sales_person_id;

    await this.allDocumentTemplates();

    // Populate items
    this.items = data.proposal_items.map(row => {
     const selectedItem = this.allItems.find(i => i.id === row.item_id);
     const unitPrice = parseFloat(row.unit_price || row.price || 0);
     const qty = parseFloat(row.quantity || 1);
     const selectedTax = row.tax_id ? this.taxes.find(t => t.id === row.tax_id) : null;
     const selectedUnit = row.unit ? this.units.find(u => u === row.unit) : null;
      return {
       item: selectedItem || { id: row.item_id, name: row.name },
       selectedTax: selectedTax,
       selectedUnit: selectedUnit,
       description: row.description || '',
       unit: row.unit || '',
       hsn_code: row.hsn_code || '',
       price: unitPrice,
       qty: qty,
       amount: unitPrice * qty
     };
    });

   }catch(error){
    this.$swalToast(error.message, 'error');
   }finally{
    this.setLoading(false);
   }
  },

  async getLeadById(id){
   try{
    const res = await axios.get(`/leads/${id}`);
    this.selectedLead = res.data.data;
    this.onLeadSelected(this.selectedLead);
   }catch(err){
    this.$swalToast("Lead not found", 'error');
   }
  },

   async getAllItems(){
    try{
     const res = await axios.get('/items/dropdown');
     this.allItems = res.data.data;
    }catch(error){
     this.$swalToast(error.message, 'error');
    }
   },
    
   addItemRow(){
    this.items.push({ item: null, selectedTax: null, selectedUnit: null, description: '', unit: '', hsn_code: '', price: 0, qty: 1, amount: 0 });
   },
   
   removeItemRow(index){
    if (this.items.length === 1) return;
    this.items.splice(index, 1);
   },

   onItemSelected(index, selectedItem){
    const row = this.items[index];
    if(!selectedItem){
     row.item = null;
     row.selectedTax = null;
     row.selectedUnit = null;
     row.description = '';
     row.unit = '';
     row.hsn_code = '';
     row.price = 0;
     row.qty = 1;
     row.amount = 0;
     return;
    }
  
    // Preserve the tax_id from the items table
    row.description = selectedItem.description || '';
    row.unit = selectedItem.unit || '';
    row.hsn_code = selectedItem.hsn_code || '';
    row.price = parseFloat(selectedItem.price || 0);
    row.qty = 1;
  
    // Set the tax for this item if it exists
    if(selectedItem.tax_id){
     row.selectedTax = this.taxes.find(t => t.id === selectedItem.tax_id);
     row.item.tax = row.selectedTax;
    }else{
     row.selectedTax = null;
     row.item.tax = null;
    }

    // Set the unit for this item if it exists (for simple array format)
    if(selectedItem.unit){
     row.selectedUnit = this.units.find(u => u === selectedItem.unit);
    }else{
     row.selectedUnit = null;
    }
  
    this.updateAmount(index);
   },

   updateAmount(index){
    const row = this.items[index];
    row.qty = Math.max(1, parseFloat(row.qty) || 1); 
    const price = parseFloat(row.price) || 0;
    row.amount = row.qty * price;
   },

  //  async onCountrySelect(country){
  //   this.to_state = null;
  //   this.states = [];
  //    if(country?.id){
  //     try{
  //      const response = await axios.get(`/states/${country.id}`);
  //      this.states = response.data.data;
  //     }catch(error){
  //      this.$swalToast(error.message, 'error');
  //     }
  //    }
  //   },

async onCountrySelect(country){
  this.to_state = null;
  this.states = [];
  if(country?.id){
    const store = useStatesStore()
    this.states = await store.loadStates(country.id)
  }
},


    async onSearch(search){
     if(!search || search.length < 2) return;
     this.loading = true;
     try{
      const res = await axios.get('/leads/dropdown', { params: { search_keyword: search } });
      this.leads = res.data.data;
     }catch(error){
      this.$swalToast(error.message, 'error');
     }finally{
      this.loading = false;
     }
    },

    async onLeadSelected(row){
     this.gst_no = row?.gst_no || ''; 
     this.to_email = row?.email || '';
     this.to_phone = row?.mobile || '';
     this.to_name = row?.company_name ?? row?.name;
     this.to_address = row?.address || '';
     this.to_city = row?.city || '';
     this.to_pincode = row?.pincode || '';
     if(row?.country !== '' || row?.country !== null){
      this.to_country = this.countries.find(c => c.name === row?.country);
      await this.onCountrySelect(this.to_country);
     }
     this.to_state = (row?.state != '') ? this.states.find(s => s.name === row?.state) : null;
     this.currency = row?.currency?.code || '';
    },

    async getTaxes(){
     this.setLoading(true);
     try{
      const response = await axios.get('/taxes');
      this.taxes = response.data.data;
     }catch(error){
      this.$swalToast(error.message, 'error');
     }finally{
      this.setLoading(false);
     }
    },

    async submitProposal(shouldDownload = false) {
     this.setLoading(true);
     this.errors = {};
      try{
       const payload = {
        id: this.id,
        lead_id: this.selectedLead?.id,
        subject: this.subject,
        to_name: this.to_name,
        to_email: this.to_email,
        to_phone: this.to_phone,
        gst_no: this.gst_no,
        to_address: this.to_address,
        to_city: this.to_city,
        to_pincode: this.to_pincode,
        to_state: this.to_state?.name,
        to_country: this.to_country?.name,
        proposal_date: this.proposal_date,
        valid_until: this.valid_until,
        sales_person_id: this.sales_person_id || null,
        document_template_id: this.template?.id || null,
        terms: this.settings.terms,
        status: this.status,
        tax_mode: this.tax_mode,
        tax_id: this.selectedTax?.id || null,
        discount: this.discount,
        items: this.items.map(row => ({
         item_id: row.item?.id || null,
         name: row.item?.name,
         description: row.description,
         unit: row.unit,
         hsn_code: row.hsn_code === 'null' || row.hsn_code === '' || row.hsn_code == null ? null : row.hsn_code,
         quantity: row.qty,
         unit_price: row.price,
         tax_id: row.selectedTax?.id || null
        }))
       };

       let response;
       if(this.id){
        response = await axios.put('/proposals/update', payload);
       }else{
        response = await axios.post('/proposals/create', payload);
       }

       this.$swalToast(response.data.message);
       this.$emit('updated');

      // SAVE AND DOWNLOAD TRIGGER 
       if(shouldDownload){
        const proposalId = this.id || response.data.data?.id;
        if(proposalId){
         await downloadPDFUtil('proposals', proposalId);
        }
       }

       this.$closeModal('proposal_modal');
       this.resetForm();

      // SAVE AND SEND TRIGGER
       if(this.should_send_mail){
        const proposal = response.data.data;
        this.$openModal('proposal_mail_modal');
        this.mailProposal(proposal);
       } 

      }catch(error){
       if(error?.type === 'validation'){
        this.errors = error.errors;
       }else{
        this.$swalToast(error.message, 'error');
       }
      }finally{
       this.setLoading(false);
      }
    },

    async deleteProposal(){
     this.errors = {};
     this.setLoading(true); 
     try{
      const response = await axios.delete(`/proposals/${this.id}/delete`);
      this.$swalToast(response.data.message);
      this.$emit('updated');
      this.$closeModal('proposal_delete_modal');
     }catch(error){
      if(error.type == 'validation'){
       this.errors = error.errors;
      }else{
       this.$swalToast(error.message, 'error'); 
      }
     }finally{
      this.setLoading(false);
     }
    },

    getItemError(index, field){
     const key = `items.${index}.${field}`;
     return this.errors[key] ? this.errors[key][0] : null;
    },

    getItemAmountDisplay(item) {
     if(this.tax_mode === 'Item'){
      if(this.clientSetting?.tax_type === 'inclusive'){
       return item.amount;
      }else{
       if(item.item?.tax){
        return item.amount * (1 + (item.item.tax.rate / 100));
       }
       return item.amount;
      }
     }
     return item.amount;
    },

    proposalAction(proposal_id, action){
     this.id = proposal_id; 
     this.action = action;
    },

    async submitAction(){
     this.errors = {}; 
     this.setLoading(true);
     try{
      const response = await axios.post('proposals/action', {
       id: this.id,
       status: this.action,
       acceptance_name: this.acceptance_name,
       acceptance_email: this.acceptance_email 
      });
      this.$swalToast(response.data.message);
      this.$emit('updated');
      this.$closeModal('proposal_action');
     }catch(error){
      if(error.type === 'validation'){
       this.errors = error.errors;
      }else{
       this.$swalToast(error.message, 'error'); 
      }
     }finally{
      this.setLoading(false);
     }
    },

    bulkAction(ids){
     this.ids = ids;
    },

    async submitBulkAction() {
     const result = await this.$confirm({});
     if(result.isConfirmed){
      this.setLoading(true); 
     try{
      const response = await axios.post('/proposals/bulk-actions', {
       ids: this.ids,
       mass_delete: this.mass_delete,
       status: this.status || '',
      });
      this.$swalToast(response.data.message);
      this.$emit('updated');
      this.$closeModal('bulk_action_proposal');
     }catch(error){
      this.$swalToast(error.message, 'error');
     }finally{
      this.setLoading(false);
     }
     }
    },

    async getAllUsers(){
     try{
     const response = await axios.get('/users/all-users');
     this.users = response.data.data; 
     }catch(error){
      console.log(error.message);
     } 
    },

    async assignHistory(id, proposal_number){
     this.id = id;
     this.modal_title = proposal_number;
     await this.getAllUsers();
     this.setLoading(true);
     try{
      const response = await axios.get(`/proposals/${id}/assignment/history`);
      this.assignment_history = response.data.data;
     }catch(error){
      this.$swalToast(error.message, 'error');
     }finally{
      this.setLoading(false);
     }
    },

    async assignProposal(){
     this.errors = {};
     this.setLoading(true);
     try{
      const payload = {
       user_id: this.user_id,
       remark: this.remark 
      };
      const response = await axios.patch(`/proposals/${this.id}/assign`, payload);
      this.$swalToast(response.data.message);
      this.$emit('updated');
      this.$closeModal('proposal_assign_modal');
     }catch(error){
      if(error.type === 'validation'){
       this.errors = error.errors;
      }else{
       this.$swalToast(error.message, 'error');
      }
     }finally{
      this.setLoading(false);
     } 
    },

    createViaLead(lead_id){
     this.add(); 
     this.getLeadById(lead_id);
    },

   onItemTaxSelected(index, selectedTax){
    const row = this.items[index];
    row.selectedTax = selectedTax;
  
    // Update the item's tax reference for calculations
    if (selectedTax) {
     row.item = row.item || {};
     row.item.tax = selectedTax;
     row.item.tax_id = selectedTax.id;
    } else {
     if (row.item) {
      row.item.tax = null;
      row.item.tax_id = null;
     }
    }
    // Recalculate amount if needed
    this.updateAmount(index);
   },
   
   onItemUnitSelected(index, selectedUnit){
    const row = this.items[index];
    row.selectedUnit = selectedUnit;  
    if(selectedUnit){
     row.unit = selectedUnit;
    }else{
     row.unit = '';
    }
   },    

    async saveAndDownload(){
     await this.submitProposal(true); 
    },

    async saveAndSend(){
     this.should_send_mail = true;
     await this.submitProposal(false);
    },

// ##############################
//  *** MAIL FUNCTIONS START ***
// ##############################

    async mailProposal(row){ 
     this.id = row.id; 
     this.modal_title = row.proposal_number;
     this.to_email = row.to_email;
     await this.byType(this.type);
    },
    
    async sendMail(){
     this.errors = {};
     this.setLoading(true);
     try{
      const payload = {
       to_email: this.to_email,
       mail_subject: this.settings.mail_subject,
       mail_body: this.settings.mail_body,
       mail_footer: this.settings.mail_footer
      };
      const response = await axios.post(`/proposals/${this.id}/email`, payload);
      this.$swalToast(response.data.message);
      this.$emit('updated');
      this.$closeModal('proposal_mail_modal');
      this.resetForm();
     }catch(error){
      if(error.type === 'validation'){
       this.errors = error.errors;
      }else{
       this.$swalToast(error.message, 'error');
      }
     }finally{
      this.setLoading(false);
     } 
    },

// ##############################
//  *** MAIL FUNCTIONS END ***
// ##############################    

    resetForm() {
     this.id = null;
     this.gst_no = '';
     this.subject = '';
     this.to_name = '';
     this.to_email = '';
     this.to_phone = '';
     this.to_address = '';
     this.to_city = '';
     this.to_pincode = '';
     this.to_state = null;
     this.to_country = null;
     this.proposal_date = '';
     this.valid_until = '';
     this.settings.terms = '';
     this.selectedLead = null;
     this.status = null;
     this.tax_mode = null;
     this.selectedTax = null;
     this.sales_person_id = null;
     this.email = '';
     this.mobile = '';
     this.address = '';
     this.city = '';
     this.pincode = '';
     this.items = [{ item: null, selectedTax: null, selectedUnit: null, description: '', unit: '', hsn_code: '', price: 0, qty: 1, amount: 0 }];
     this.discount = 0;
     this.errors = {};
    }
  }
};
</script>

<style scoped>
/* ─────────────────────────────────────────────
   PROPOSAL MODAL — MATCHING QUOTATION UI
───────────────────────────────────────────── */
 
/* Main area */
.pm-main {
  flex: 1; display: flex; flex-direction: column; overflow: hidden;
  background: #f1f5f9;
}
 
/* Topbar */
.pm-topbar {
  background: #fff; border-bottom: 1px solid #e2e8f0;
  padding: 12px 22px;
  display: flex; align-items: center; justify-content: space-between;
  flex-shrink: 0;
}
.pm-page-title { font-size: 14px; font-weight: 700; color: #0f172a; }
.pm-page-sub { font-size: 11px; color: #94a3b8; }
.pm-close-btn {
  width: 30px; height: 30px; border-radius: 7px;
  background: #f1f5f9; border: 1px solid #ef4444;
  display: flex; align-items: center; justify-content: center;
  cursor: pointer; font-size: 13px; transition: all .15s;
  color: #ef4444;
}
.pm-close-btn:hover { background: #fee2e2; border-color: #fca5a5; color: #ef4444; }
 
/* Scrollable body */
.pm-body {
  flex: 1; overflow-y: auto; padding: 18px 22px;
  scrollbar-width: thin; scrollbar-color: #cbd5e1 transparent;
}
.pm-body::-webkit-scrollbar { width: 4px; }
.pm-body::-webkit-scrollbar-thumb { background: #cbd5e1; border-radius: 10px; }
 
/* Section cards */
.pm-card {
  background: #fff; border: 1px solid #e2e8f0;
  border-radius: 12px; margin-bottom: 14px; overflow: visible;
}
.pm-card-head {
  display: flex; align-items: center; gap: 9px;
  padding: 10px 16px; background: #f8fafc;
  border-bottom: 1px solid #e8edf3;
}
.pm-card-icon {
  width: 24px; height: 24px; border-radius: 6px;
  display: flex; align-items: center; justify-content: center;
  font-size: 12px; flex-shrink: 0;
}
.pm-card-title { font-size: 12px; font-weight: 700; color: #0f172a; letter-spacing: .1px; }
.pm-card-body { padding: 14px 16px; }
 
/* Form controls */
.pm-label {
  font-size: 11px; font-weight: 600; color: #475569;
  margin-bottom: 4px; display: block;
}
.pm-label .req { color: #f43f5e; margin-left: 2px; }
.pm-input, .pm-select, .pm-textarea {
  width: 100%; border: 1.5px solid #e2e8f0; border-radius: 8px;
  padding: 0 11px; font-size: 12.5px; color: #1e293b;
  background: #fff; outline: none;
  transition: border-color .15s, box-shadow .15s;
}
.pm-input, .pm-select { height: 35px; }
.pm-textarea { padding: 8px 11px; resize: vertical; }
.pm-input:focus, .pm-select:focus, .pm-textarea:focus {
  border-color: #3b82f6;
  box-shadow: 0 0 0 3px rgba(59,130,246,.1);
}
.pm-input.err { border-color: #f43f5e; box-shadow: 0 0 0 3px rgba(244,63,94,.1); }
.pm-err-msg {
  font-size: 10.5px; color: #f43f5e; margin-top: 3px;
  display: flex; align-items: center; gap: 3px;
}
 
/* Item row */
.pm-item-card {
  background: #fff; border: 1.5px solid #e8edf3;
  border-radius: 10px; padding: 14px 14px 10px;
  margin-bottom: 10px; position: relative;
  transition: border-color .15s, box-shadow .15s;
}
.pm-item-card:hover { border-color: #bfdbfe; box-shadow: 0 2px 10px rgba(59,130,246,.07); }
.pm-item-num {
  position: absolute; top: -9px; left: 14px;
  width: 19px; height: 19px; background: #3b82f6; color: #fff;
  border-radius: 50%; font-size: 9px; font-weight: 700;
  display: flex; align-items: center; justify-content: center;
}
.pm-remove-btn {
  width: 30px; height: 30px; border-radius: 7px;
  background: #fff0f3; border: 1.5px solid #fecdd3;
  color: #f43f5e; font-size: 13px; cursor: pointer;
  display: flex; align-items: center; justify-content: center;
  transition: all .15s;
}
.pm-remove-btn:hover { background: #f43f5e; border-color: #f43f5e; color: #fff; }
 
/* Add item button */
.pm-add-item-btn {
  display: inline-flex; align-items: center; gap: 6px;
  padding: 7px 14px; background: #eff6ff;
  border: 1.5px dashed #93c5fd; border-radius: 8px;
  color: #2563eb; font-size: 11.5px; font-weight: 600;
  cursor: pointer; transition: all .15s;
}
.pm-add-item-btn:hover { background: #dbeafe; border-color: #3b82f6; }
 
/* Pricing summary */
.pm-price-row {
  display: flex; align-items: center; justify-content: space-between;
  padding: 7px 0; border-bottom: 1px dashed #f1f5f9;
}
.pm-price-row:last-of-type { border-bottom: none; }
.pm-price-label { font-size: 12px; color: #64748b; font-weight: 500; }
.pm-price-val { font-size: 12.5px; font-weight: 700; color: #1e293b; }
.pm-price-input-box {
  display: flex; align-items: center;
  border: 1.5px solid #e2e8f0; border-radius: 7px;
  overflow: hidden; width: 126px; background: #fff;
}
.pm-price-prefix {
  padding: 0 7px; font-size: 10px; font-weight: 600;
  color: #94a3b8; background: #f8fafc;
  border-right: 1.5px solid #e2e8f0;
  height: 30px; display: flex; align-items: center;
}
.pm-price-num-input {
  border: none; outline: none; width: 100%;
  text-align: right; font-size: 12px; font-weight: 600;
  color: #1e293b; padding: 0 8px; height: 30px; background: transparent;
}
.pm-grand-box {
  display: flex; align-items: center; justify-content: space-between;
  background: linear-gradient(135deg,#0f172a,#1e3a5f);
  border-radius: 10px; padding: 13px 18px; margin-top: 10px;
}
.pm-grand-label { font-size: 12.5px; font-weight: 700; color: #93c5fd; display: flex; align-items: center; gap: 6px; }
.pm-grand-val { font-size: 18px; font-weight: 800; color: #fff; letter-spacing: -.5px; }
 
/* Action footer */
.pm-footer {
  background: #fff; border-top: 1px solid #e2e8f0;
  padding: 11px 22px; display: flex; align-items: center; gap: 8px; flex-shrink: 0; flex-wrap: wrap;
}
 
/* Reusable buttons */
.pm-btn {
  display: inline-flex; align-items: center; gap: 5px;
  padding: 7px 15px; border-radius: 8px; font-size: 12px;
  font-weight: 600; cursor: pointer; border: 1.5px solid transparent;
  transition: all .15s; text-decoration: none; white-space: nowrap;
}
.pm-btn-primary {
  background: linear-gradient(135deg,#2563eb,#3b82f6);
  color: #fff; border-color: #2563eb;
  box-shadow: 0 2px 8px rgba(37,99,235,.25);
}
.pm-btn-primary:hover { background: linear-gradient(135deg,#1d4ed8,#2563eb); }
.pm-btn-success { background: #fff; color: #16a34a; border-color: #86efac; }
.pm-btn-success:hover { background: #f0fdf4; border-color: #16a34a; }
.pm-btn-info { background: #fff; color: #0284c7; border-color: #bae6fd; }
.pm-btn-info:hover { background: #f0f9ff; border-color: #0284c7; }
.pm-btn-ghost { background: #f8fafc; color: #475569; border-color: #e2e8f0; }
.pm-btn-ghost:hover { background: #f1f5f9; }
.pm-btn-danger { background: #f43f5e; color: #fff; border-color: #f43f5e; }
.pm-btn-danger:hover { background: #e11d48; border-color: #e11d48; }
 
/* vue-select theming */
:deep(.vs__dropdown-toggle) {
  border: 1.5px solid #e2e8f0 !important; border-radius: 8px !important;
  min-height: 35px !important; padding: 0 8px !important;
  transition: border-color .15s, box-shadow .15s !important;
}
:deep(.vs__dropdown-toggle:focus-within) {
  border-color: #3b82f6 !important;
  box-shadow: 0 0 0 3px rgba(59,130,246,.1) !important;
}
:deep(.vs__search) { font-size: 12.5px !important; color: #1e293b !important; }
:deep(.vs__selected) {
  font-size: 12px !important; color: #1e293b !important;
  background: #eff6ff !important; border: 1px solid #bfdbfe !important;
  border-radius: 5px !important;
}
</style>
 
 
<template>
 
<!-- ═══════════════════════════════════════════════
     ADD / EDIT PROPOSAL — FULLSCREEN MODAL
═══════════════════════════════════════════════ -->
<div class="modal fade" id="proposal_modal" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-fullscreen" style="margin:0;">
    <div class="modal-content border-0 h-100" style="border-radius:0;">
 
      <!-- ░░ MAIN CONTENT ░░ -->
      <div class="pm-main">
 
        <!-- Topbar -->
        <div class="pm-topbar">
          <div>
            <div class="pm-page-title">{{ id ? 'Edit Proposal' : 'Create New Proposal' }}</div>
            <div class="pm-page-sub">{{ id ? 'Update proposal details below' : 'Fill in the details to generate a new proposal' }}</div>
          </div>
          <div class="d-flex align-items-center gap-2">
            <button type="button" class="pm-close-btn" data-bs-dismiss="modal">
              <i class="ti ti-x"></i>
            </button>
          </div>
        </div>
 
        <!-- Form -->
        <form @submit.prevent="submitProposal(false)" class="d-flex flex-column" style="flex:1;overflow:hidden;">
 
          <div class="pm-body">
 
            <!-- ── 1. Proposal Details ── -->
            <div class="pm-card">
              <div class="pm-card-head">
                <div class="pm-card-icon" style="background:#eff6ff;"><i class="ti ti-file-description" style="color:#3b82f6;"></i></div>
                <span class="pm-card-title">Proposal Details</span>
              </div>
              <div class="pm-card-body">
                <div class="row g-3">
 
                  <div class="col-md-3">
                    <label class="pm-label">Subject <span class="req">*</span></label>
                    <input type="text" class="pm-input" :class="{'err': errors.subject}" v-model="subject" placeholder="Enter proposal subject..." />
                    <div v-if="errors.subject" class="pm-err-msg"><i class="ti ti-alert-circle"></i>{{ errors.subject[0] }}</div>
                  </div>
 
                  <div class="col-md-3">
                    <label class="pm-label">Client <span class="req">*</span></label>
                    <vue-select v-model="selectedLead" :options="leads" :loading="loading" :filterable="false"
                      @search="onSearch" @update:modelValue="onLeadSelected" label="name"
                      placeholder="Search and select a lead"/>
                    <div v-if="errors.lead_id" class="pm-err-msg"><i class="ti ti-alert-circle"></i>{{ errors.lead_id[0] }}</div>
                  </div>
 
                  <div class="col-md-3">
                    <label class="pm-label">Sales Person <span class="req">*</span></label>
                    <vue-select :options="users" label="name" placeholder="Select sales person" :reduce="u => u.id" v-model="sales_person_id"/>
                    <div v-if="errors.sales_person_id" class="pm-err-msg"><i class="ti ti-alert-circle"></i>{{ errors.sales_person_id[0] }}</div>
                  </div>
 
                  <div class="col-md-3">
                    <label class="pm-label">Status <span class="req">*</span></label>
                    <vue-select :options="statuses" v-model="status"/>
                    <div v-if="errors.status" class="pm-err-msg"><i class="ti ti-alert-circle"></i>{{ errors.status[0] }}</div>
                  </div>
 
                  <div class="col-md-3">
                    <label class="pm-label">Date <span class="req">*</span></label>
                    <input type="date" class="pm-input" :class="{'err': errors.proposal_date}" v-model="proposal_date" />
                    <div v-if="errors.proposal_date" class="pm-err-msg"><i class="ti ti-alert-circle"></i>{{ errors.proposal_date[0] }}</div>
                  </div>
 
                  <div class="col-md-3">
                    <label class="pm-label">Valid Until <span class="req">*</span></label>
                    <input type="date" class="pm-input" :class="{'err': errors.valid_until}" v-model="valid_until" />
                    <div v-if="errors.valid_until" class="pm-err-msg"><i class="ti ti-alert-circle"></i>{{ errors.valid_until[0] }}</div>
                  </div>
 
                  <div class="col-md-3">
                    <label class="pm-label">Template</label>
                    <vue-select :options="templates" label="name" v-model="template" placeholder="Choose template"/>
                    <div v-if="errors.template_id" class="pm-err-msg"><i class="ti ti-alert-circle"></i>{{ errors.template_id[0] }}</div>
                  </div>
 
                  <div class="col-md-2">
                    <label class="pm-label">Tax Mode <span class="req">*</span></label>
                    <vue-select :options="tax_modes" v-model="tax_mode"/>
                    <div v-if="errors.tax_mode" class="pm-err-msg"><i class="ti ti-alert-circle"></i>{{ errors.tax_mode[0] }}</div>
                  </div>
 
                </div>
              </div>
            </div>
 
            <!-- ── 2. Client Info ── -->
            <div class="pm-card">
              <div class="pm-card-head">
                <div class="pm-card-icon" style="background:#f0fdf4;"><i class="ti ti-user" style="color:#16a34a;"></i></div>
                <span class="pm-card-title">Client Information</span>
              </div>
              <div class="pm-card-body">
                <div class="row g-3">
 
                  <div class="col-lg-2">
                    <label class="pm-label">To (Name) <span class="req">*</span></label>
                    <input type="text" class="pm-input" v-model="to_name" placeholder="Client full name" />
                    <div v-if="errors.to_name" class="pm-err-msg"><i class="ti ti-alert-circle"></i>{{ errors.to_name[0] }}</div>
                  </div>
                  <div class="col-lg-2 col-12">
                    <label class="pm-label">Email</label>
                    <input type="email" class="pm-input" v-model="to_email" placeholder="client@email.com" />
                    <div v-if="errors.to_email" class="pm-err-msg"><i class="ti ti-alert-circle"></i>{{ errors.to_email[0] }}</div>
                  </div>
                  <div class="col-lg-2 col-12">
                    <label class="pm-label">Phone</label>
                    <input type="text" class="pm-input" v-model="to_phone" placeholder="+91 00000 00000" />
                    <div v-if="errors.to_phone" class="pm-err-msg"><i class="ti ti-alert-circle"></i>{{ errors.to_phone[0] }}</div>
                  </div>
                  <div class="col-lg-2 col-12">
                    <label class="pm-label">GST No</label>
                    <input type="text" class="pm-input" v-model="gst_no" placeholder="22AAAAA0000A1Z5" />
                    <div v-if="errors.gst_no" class="pm-err-msg"><i class="ti ti-alert-circle"></i>{{ errors.gst_no[0] }}</div>
                  </div>
 
                  <div class="col-md-2">
                    <label class="pm-label">City</label>
                    <input type="text" class="pm-input" v-model="to_city" />
                    <div v-if="errors.to_city" class="pm-err-msg"><i class="ti ti-alert-circle"></i>{{ errors.to_city[0] }}</div>
                  </div>
                  <div class="col-md-2">
                    <label class="pm-label">Zip Code</label>
                    <input type="text" class="pm-input" v-model="to_pincode" />
                    <div v-if="errors.to_pincode" class="pm-err-msg"><i class="ti ti-alert-circle"></i>{{ errors.to_pincode[0] }}</div>
                  </div>
                  <div class="col-md-2">
                    <label class="pm-label">Country</label>
                    <vue-select v-model="to_country" :options="countries" label="name" placeholder="Select country"
                      @update:modelValue="onCountrySelect"/>
                    <div v-if="errors.to_country" class="pm-err-msg"><i class="ti ti-alert-circle"></i>{{ errors.to_country[0] }}</div>
                  </div>
                  <div class="col-md-2">
                    <label class="pm-label">State</label>
                    <vue-select v-model="to_state" :options="states" label="name" placeholder="Select state"/>
                    <div v-if="errors.to_state" class="pm-err-msg"><i class="ti ti-alert-circle"></i>{{ errors.to_state[0] }}</div>
                  </div>

                    <div class="col-lg-4 col-12">
                    <label class="pm-label">Address</label>
                    <textarea class="pm-textarea" rows="2" v-model="to_address" placeholder="Full billing address..."></textarea>
                    <div v-if="errors.to_address" class="pm-err-msg"><i class="ti ti-alert-circle"></i>{{ errors.to_address[0] }}</div>
                  </div>
 
                </div>
              </div>
            </div>
 
            <!-- ── Invoice-mode Tax ── -->
            <div class="pm-card" v-if="tax_mode == 'Invoice'">
              <div class="pm-card-head">
                <div class="pm-card-icon" style="background:#fffbeb;"><i class="ti ti-percent" style="color:#f59e0b;"></i></div>
                <span class="pm-card-title">Tax Information (Invoice Level)</span>
              </div>
              <div class="pm-card-body">
                <div class="row">
                  <div class="col-md-4">
                    <label class="pm-label">Tax Rate</label>
                    <vue-select :options="taxes" label="name" placeholder="Select tax" v-model="selectedTax"/>
                    <div v-if="errors.tax_id" class="pm-err-msg"><i class="ti ti-alert-circle"></i>{{ errors.tax_id[0] }}</div>
                  </div>
                </div>
              </div>
            </div>
 
            <!-- ── 3. Line Items ── -->
            <div class="pm-card">
              <div class="pm-card-head">
                <div class="pm-card-icon" style="background:#fffbeb;"><i class="ti ti-list-details" style="color:#f59e0b;"></i></div>
                <span class="pm-card-title">Proposal Line Items</span>
                <button type="button" class="pm-add-item-btn ms-auto" @click="addItemRow">
                  <i class="ti ti-plus"></i> Add Item
                </button>
              </div>
              <div class="pm-card-body">
 
                <div v-for="(item, index) in items" :key="index" class="pm-item-card">
                  <div class="pm-item-num">{{ index + 1 }}</div>
                  <input type="hidden" v-model="item.hsn_code" />
 
                  <div class="row g-2 align-items-end">
 
                    <div :class="tax_mode === 'Item' ? 'col-md-3' : 'col-md-4'">
                      <label class="pm-label">Item</label>
                      <vue-select :options="allItems" label="name" v-model="item.item" :get-option-label="item => `${item.name} - ${item.code ?? item.id}`"
                        @update:modelValue="val => onItemSelected(index, val)" placeholder="Select item"/>
                      <div class="pm-err-msg" v-if="getItemError(index, 'item_id')">
                        <i class="ti ti-alert-circle"></i>{{ getItemError(index, 'item_id') }}
                      </div>
                    </div>
 
                    <div class="col-md-2" v-if="tax_mode === 'Item'">
                      <label class="pm-label">Tax</label>
                      <vue-select :options="taxes" label="name" v-model="item.selectedTax" placeholder="Tax"
                        @update:modelValue="val => onItemTaxSelected(index, val)"/>
                      <div class="pm-err-msg" v-if="getItemError(index, 'tax_id')">
                        <i class="ti ti-alert-circle"></i>{{ getItemError(index, 'tax_id') }}
                      </div>
                    </div>
 
                    <div :class="tax_mode === 'Item' ? 'col-md-2' : 'col-md-2'">
                      <label class="pm-label">Unit Cost</label>
                      <input type="number" class="pm-input" v-model.number="item.price" @input="updateAmount(index)" placeholder="0.00"/>
                      <div class="pm-err-msg" v-if="getItemError(index, 'unit_price')">
                        <i class="ti ti-alert-circle"></i>{{ getItemError(index, 'unit_price') }}
                      </div>
                    </div>
 
                    <div class="col-md-2">
                      <label class="pm-label">Unit</label>
                      <vue-select :options="units" v-model="item.selectedUnit" placeholder="Unit"
                        @update:modelValue="val => onItemUnitSelected(index, val)"/>
                    </div>
 
                    <div class="col-md-1">
                      <label class="pm-label">Qty</label>
                      <input type="number" class="pm-input" v-model.number="item.qty" @input="updateAmount(index)" placeholder="1"/>
                      <div class="pm-err-msg" v-if="getItemError(index, 'quantity')">
                        <i class="ti ti-alert-circle"></i>{{ getItemError(index, 'quantity') }}
                      </div>
                    </div>
 
                    <div :class="tax_mode === 'Item' ? 'col-md-1' : 'col-md-2'">
                      <label class="pm-label">Amount</label>
                      <input type="text" class="pm-input" :value="getItemAmountDisplay(item).toFixed(2)" readonly
                        style="background:#f8fafc;font-weight:700;color:#1e293b;" />
                    </div>
 
                    <div class="col-md-1 d-flex align-items-end">
                      <button type="button" class="pm-remove-btn" @click="removeItemRow(index)">
                        <i class="ti ti-trash"></i>
                      </button>
                    </div>
 
                    <div class="col-12">
                      <label class="pm-label">Description</label>
                      <ckeditor :ref="`itemEditor${index}`" :editor="editor" v-model="item.description" :config="editorConfig" tag-name="textarea"/>
                    </div>
 
                  </div>
                </div>
 
                <div v-if="!items.length" style="text-align:center;padding:28px;color:#94a3b8;">
                  <i class="ti ti-inbox" style="font-size:28px;display:block;margin-bottom:6px;opacity:.4;"></i>
                  No items added yet.
                </div>
 
              </div>
            </div>
 
            <!-- ── 4. Terms ── -->
            <div class="pm-card">
              <div class="pm-card-head">
                <div class="pm-card-icon" style="background:#faf5ff;"><i class="ti ti-notes" style="color:#8b5cf6;"></i></div>
                <span class="pm-card-title">Terms & Conditions</span>
              </div>
              <div class="pm-card-body">
                <ckeditor :editor="editor" v-model="settings.terms" :config="editorConfig"></ckeditor>
                <div class="pm-err-msg" v-if="errors.terms"><i class="ti ti-alert-circle"></i>{{ errors.terms[0] }}</div>
              </div>
            </div>
 
            <!-- ── 5. Pricing Summary ── -->
            <div class="pm-card">
              <div class="pm-card-head">
                <div class="pm-card-icon" style="background:#f0fdf4;"><i class="ti ti-calculator" style="color:#16a34a;"></i></div>
                <span class="pm-card-title">Pricing Summary</span>
              </div>
              <div class="pm-card-body">
                <div style="max-width:400px;margin-left:auto;">
 
                  <div class="pm-price-row">
                    <span class="pm-price-label">Subtotal</span>
                    <span class="pm-price-val">{{ currency }} {{ totalAmount.toFixed(2) }}</span>
                  </div>
 
                  <div class="pm-price-row" v-if="showTaxInfo && taxAmount">
                    <span class="pm-price-label">{{ tax_mode === 'Invoice' ? 'Tax — ' + selectedTax?.name : 'Item Taxes' }}</span>
                    <span class="pm-price-val" style="color:#2563eb;">{{ currency }} {{ taxAmount.toFixed(2) }}</span>
                  </div>
 
                  <div class="pm-price-row">
                    <label class="pm-price-label mb-0">Discount</label>
                    <div class="pm-price-input-box">
                      <span class="pm-price-prefix">{{ currency || '₹' }}</span>
                      <input type="number" min="0" class="pm-price-num-input" v-model.number="discount" />
                    </div>
                  </div>
 
                  <div class="pm-grand-box">
                    <div class="pm-grand-label"><i class="ti ti-check" style="font-size:13px;"></i> Grand Total</div>
                    <span class="pm-grand-val">{{ currency }} {{ grandTotal.toFixed(2) }}</span>
                  </div>
 
                </div>
              </div>
            </div>
 
          </div><!-- /pm-body -->
 
          <!-- Footer -->
          <div class="pm-footer">
            <button type="button" class="pm-btn pm-btn-ghost me-auto" @click="addItemRow">
              <i class="ti ti-plus"></i> Add Item
            </button>
            <button type="button" class="pm-btn pm-btn-success" @click="saveAndDownload">
              <i class="ti ti-download"></i> Save & Download
            </button>
            <button type="button" class="pm-btn pm-btn-info" @click="saveAndSend" v-if="settings?.send_on_email">
              <i class="ti ti-send"></i> Save & Send
            </button>
            <button type="submit" class="pm-btn pm-btn-primary">
              <i class="ti ti-device-floppy"></i> Save Proposal
            </button>
          </div>
 
        </form>
      </div><!-- /pm-main -->
 
    </div>
  </div>
</div>
<!-- /ADD PROPOSAL MODAL -->
 
 
<!-- ═══════════════════════════════════════════════
     MAIL MODAL
═══════════════════════════════════════════════ -->
<div class="modal fade" id="proposal_mail_modal">
<div class="modal-dialog modal-dialog-centered modal-lg">
  <div class="modal-content" style="border:none;border-radius:16px;overflow:hidden;">
    <div class="modal-header" style="background:linear-gradient(135deg,#0f172a,#1e3a5f);padding:15px 20px;border:none;">
      <div>
        <h4 class="modal-title" style="font-size:14px;font-weight:700;color:#fff;margin:0;">{{ modal_title }}</h4>
        <div style="font-size:11px;color:#64748b;margin-top:1px;">Send this proposal via email</div>
      </div>
      <button type="button" class="btn-close custom-btn-close" data-bs-dismiss="modal" aria-label="Close" style="filter:invert(1);opacity:.6;"><i class="ti ti-x"></i></button>
    </div>
    <form @submit.prevent="sendMail">
     <div class="modal-body" style="padding:20px;">
      <div class="mb-3"><DocumentPlaceholder/></div>
      <div class="mb-3">
        <label class="pm-label">To Email</label>
        <input type="text" class="pm-input" v-model="to_email" placeholder="recipient@email.com" />
        <div class="pm-err-msg" v-if="errors.to_email"><i class="ti ti-alert-circle"></i>{{ errors.to_email[0] }}</div>
      </div>
      <div class="mb-3">
        <label class="pm-label">Email Subject</label>
        <input type="text" class="pm-input" v-model="settings.mail_subject" />
        <div class="pm-err-msg" v-if="errors.mail_subject"><i class="ti ti-alert-circle"></i>{{ errors.mail_subject[0] }}</div>
      </div>
      <div class="mb-3">
        <label class="pm-label">Email Body</label>
        <ckeditor :editor="editor" v-model="settings.mail_body" :config="editorConfig"></ckeditor>
        <div class="pm-err-msg" v-if="errors.mail_body"><i class="ti ti-alert-circle"></i>{{ errors.mail_body[0] }}</div>
      </div>
      <div class="mb-3">
        <label class="pm-label">Email Footer</label>
        <ckeditor :editor="editor" v-model="settings.mail_footer" :config="editorConfig"></ckeditor>
        <div class="pm-err-msg" v-if="errors.mail_footer"><i class="ti ti-alert-circle"></i>{{ errors.mail_footer[0] }}</div>
      </div>
     </div>
     <div class="modal-footer" style="border-top:1px solid #e2e8f0;padding:11px 20px;gap:8px;">
      <button type="button" class="pm-btn pm-btn-ghost" data-bs-dismiss="modal">Cancel</button>
      <button type="submit" class="pm-btn pm-btn-primary"><i class="ti ti-send"></i> Send Email</button>
     </div>
    </form>
  </div>
</div>
</div>
<!-- /MAIL -->
 
 
<!-- ═══════════════════════════════════════════════
     DELETE MODAL
═══════════════════════════════════════════════ -->
<div class="modal fade" id="proposal_delete_modal">
<div class="modal-dialog modal-dialog-centered">
<div class="modal-content" style="border:none;border-radius:16px;overflow:hidden;">
<div class="modal-body" style="padding:32px 24px;text-align:center;">
  <div style="width:60px;height:60px;background:#fff0f3;border-radius:14px;display:flex;align-items:center;justify-content:center;margin:0 auto 16px;">
    <i class="ti ti-trash-x" style="font-size:26px;color:#f43f5e;"></i>
  </div>
  <h4 style="font-weight:700;color:#0f172a;margin-bottom:8px;">Delete Proposal?</h4>
  <p style="color:#64748b;font-size:13px;margin-bottom:24px;">This action cannot be undone. All selected items will be permanently removed.</p>
  <div class="d-flex justify-content-center gap-3">
    <a href="javascript:void(0);" class="pm-btn pm-btn-ghost" data-bs-dismiss="modal">Cancel</a>
    <a href="javascript:void(0);" class="pm-btn pm-btn-danger" @click="deleteProposal">
      <i class="ti ti-trash"></i> Yes, Delete
    </a>
  </div>
</div>
</div>
</div>
</div>
<!-- /Delete Modal -->
 
 
<!-- ═══════════════════════════════════════════════
     ACTION MODAL
═══════════════════════════════════════════════ -->
<div class="modal fade" id="proposal_action">
  <div class="modal-dialog modal-dialog-centered modal-sm">
  <div class="modal-content" style="border:none;border-radius:14px;overflow:hidden;">
  <div class="modal-header" style="background:#f8fafc;border-bottom:1px solid #e2e8f0;padding:13px 18px;">
    <h4 class="modal-title" style="font-size:14px;font-weight:700;color:#0f172a;">{{ action }}</h4>
    <button type="button" class="btn-close custom-btn-close" data-bs-dismiss="modal" aria-label="Close"><i class="ti ti-x"></i></button>
  </div>
  <form @submit.prevent="submitAction">
  <div class="modal-body" style="padding:18px;">
    <div class="mb-3">
      <label class="pm-label">Full Name</label>
      <input type="text" class="pm-input" v-model="acceptance_name" />
      <div v-if="errors.acceptance_name" class="pm-err-msg"><i class="ti ti-alert-circle"></i>{{ errors.acceptance_name[0] }}</div>
    </div>
    <div class="mb-3">
      <label class="pm-label">Email ID</label>
      <input type="text" class="pm-input" v-model="acceptance_email" />
      <div v-if="errors.acceptance_email" class="pm-err-msg"><i class="ti ti-alert-circle"></i>{{ errors.acceptance_email[0] }}</div>
    </div>
  </div>
  <div class="modal-footer" style="border-top:1px solid #e2e8f0;padding:11px 18px;gap:8px;">
    <button type="button" class="pm-btn pm-btn-ghost" data-bs-dismiss="modal">Cancel</button>
    <button type="submit" class="pm-btn pm-btn-primary">Submit</button>
  </div>
  </form>
  </div>
  </div>
</div>
 
 
<!-- ═══════════════════════════════════════════════
     ASSIGN MODAL
═══════════════════════════════════════════════ -->
<div class="modal fade" id="proposal_assign_modal">
<div class="modal-dialog modal-dialog-centered modal-lg">
<div class="modal-content" style="border:none;border-radius:16px;overflow:hidden;">
<div class="modal-header" style="background:#f8fafc;border-bottom:1px solid #e2e8f0;padding:13px 18px;">
  <h4 class="modal-title" style="font-size:14px;font-weight:700;color:#0f172a;">{{ modal_title }}</h4>
  <button type="button" class="btn-close custom-btn-close" data-bs-dismiss="modal" aria-label="Close"><i class="ti ti-x"></i></button>
</div>
<form @submit.prevent="assignProposal">
  <div class="modal-body" style="padding:18px;">
    <div class="row g-3">
      <div class="col-md-4">
        <label class="pm-label">Assign To</label>
        <select class="pm-select" v-model="user_id">
          <option v-for="row in users" :key="row.id" :value="row.id">{{ row.name }}</option>
        </select>
        <div v-if="errors.user_id" class="pm-err-msg"><i class="ti ti-alert-circle"></i>{{ errors.user_id[0] }}</div>
      </div>
      <div class="col-md-6">
        <label class="pm-label">Remark</label>
        <input type="text" class="pm-input" v-model="remark" placeholder="Add a note..." />
        <div v-if="errors.remark" class="pm-err-msg"><i class="ti ti-alert-circle"></i>{{ errors.remark[0] }}</div>
      </div>
      <div class="col-md-2 d-flex align-items-end">
        <button type="submit" class="pm-btn pm-btn-primary w-100">Assign</button>
      </div>
    </div>
  </div>
  <div class="modal-footer" style="border-top:1px solid #e2e8f0;padding:14px 18px;flex-direction:column;align-items:stretch;">
    <table class="table table-sm mb-0" style="font-size:12px;" v-if="assignment_history.length">
      <thead style="background:#f8fafc;">
        <tr>
          <th style="font-weight:600;color:#64748b;">#</th>
          <th style="font-weight:600;color:#64748b;">By</th>
          <th style="font-weight:600;color:#64748b;">From</th>
          <th style="font-weight:600;color:#64748b;">To</th>
          <th style="font-weight:600;color:#64748b;">Status</th>
          <th style="font-weight:600;color:#64748b;">Remark</th>
          <th style="font-weight:600;color:#64748b;">Date</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(row, index) in assignment_history" :key="row.id">
          <td>{{ index + 1 }}</td>
          <td>{{ row.assign_by.name }}</td>
          <td>{{ row.assign_from.name }}</td>
          <td>{{ row.assign_to.name }}</td>
          <td><span style="padding:2px 8px;background:#f0fdf4;color:#16a34a;border-radius:20px;font-size:10px;font-weight:600;">{{ row.status }}</span></td>
          <td>{{ row.remark }}</td>
          <td>{{ $formatDate(row.created_at, 'DD-MM-YY, hh:mm a') }}</td>
        </tr>
      </tbody>
    </table>
    <div v-else style="text-align:center;padding:14px;color:#94a3b8;font-size:13px;">No assignment history.</div>
  </div>
</form>
</div>
</div>
</div>
 
 
<!-- ═══════════════════════════════════════════════
     BULK ACTION MODAL
═══════════════════════════════════════════════ -->
<div class="modal fade" id="bulk_action_proposal">
<div class="modal-dialog modal-dialog-centered">
  <div class="modal-content" style="border:none;border-radius:16px;overflow:hidden;">
    <div class="modal-header" style="background:#f8fafc;border-bottom:1px solid #e2e8f0;padding:13px 18px;">
      <h4 class="modal-title" style="font-size:14px;font-weight:700;color:#0f172a;">Bulk Actions</h4>
      <button type="button" class="btn-close custom-btn-close" data-bs-dismiss="modal" aria-label="Close"><i class="ti ti-x"></i></button>
    </div>
    <form @submit.prevent="submitBulkAction">
      <div class="modal-body" style="padding:18px;">
        <div style="display:flex;align-items:center;gap:10px;padding:12px 14px;background:#fff0f3;border:1px solid #fecdd3;border-radius:10px;">
          <input type="checkbox" class="form-check-input" name="mass_delete" id="mass_delete_proposal" v-model="mass_delete"
            style="width:15px;height:15px;accent-color:#f43f5e;flex-shrink:0;margin-top:0;" />
          <div>
            <label for="mass_delete_proposal" style="font-size:12.5px;font-weight:600;color:#991b1b;cursor:pointer;margin:0;">Mass Delete</label>
            <div style="font-size:11px;color:#f87171;">Permanently remove all selected proposals</div>
          </div>
        </div>
 
        <div class="mt-3" v-if="!mass_delete">
          <label class="pm-label">Change Status</label>
          <vue-select :options="statuses" label="name" v-model="status" />
        </div>
      </div>
      <div class="modal-footer" style="border-top:1px solid #e2e8f0;padding:11px 18px;gap:8px;">
        <button type="button" class="pm-btn pm-btn-ghost" data-bs-dismiss="modal">Cancel</button>
        <button type="submit" class="pm-btn pm-btn-primary">Confirm</button>
      </div>
    </form>
  </div>
</div>
</div>
 
</template>
